import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
const temas = ['Identidad y construcción personal', 'Autoestima', 'Cambios en la adolescencia', 'Vínculos saludables', 'Consentimiento', 'Violencia en el noviazgo', 'Bullying', 'Ciberbullying', 'Grooming', 'Redes sociales e identidad digital', 'Diversidad', 'Derechos', 'Salud sexual integral', 'Métodos anticonceptivos e ITS', 'Embarazo en la adolescencia', 'Consumo de alcohol', 'Drogas y consumos problemáticos', 'Vapeadores', 'Salud mental', 'Presión de grupo', 'Violencia y seguridad escolar', 'Ciudadanía digital', 'Participación social', 'Proyecto de vida'];
export function IncludesSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-209" data-mp="1l2lzjttwofi5">
      <div className="max-w-3xl mx-auto" data-id="element-210" data-mp="3kefzitbwj6bn">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-211" data-mp="3kdd88kao31v7">
          ¿QUÉ INCLUYE MEGAPACK ESI SECUNDARIA?
        </h2>

        <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100 mb-5" data-id="element-212" data-mp="3ugrz5ecrhpjk">
          <h3 className="text-2xl font-bold mb-3 text-[#000000]" data-id="element-213" data-mp="3uiv20yz0jd5p">
            📚 Cuadernillo completo de Educación Sexual Integral
          </h3>

          <div className="flex justify-center mb-4" data-id="element-214" data-mp="3kjdwchjrgz9q">
            <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria" className="w-[280px] h-auto object-contain drop-shadow-lg rounded-lg" data-id="element-215" data-mp="3kkow86a35mvk" />
          </div>

          <p className="text-lg font-medium mb-3" data-id="element-216" data-mp="7c2dpbbo7h64">
            Incluye <span className="font-black" data-id="element-217" data-mp="7bj7grvduh7x">25 temas fundamentales</span>{' '}
            para trabajar durante todo el año escolar. Entre ellos:
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-base text-gray-800 mb-4" data-id="element-218" data-mp="100zsh4goavu4">
            {temas.map(tema => <li key={tema} className="flex items-start" data-id="element-219" data-mp="14t12ejqdcagz">
                <span className="text-blue-500 mr-2 font-bold" data-id="element-220" data-mp="1enyj4x7phm7s">•</span>
                <span data-id="element-221" data-mp="1el2mdc7lh3kx">{tema}</span>
              </li>)}
          </ul>

          <p className="text-lg font-medium mb-2" data-id="element-222" data-mp="19m97pggkn6j6">Cada tema incluye:</p>

          <ul className="space-y-1.5 text-lg text-gray-800 mb-4 pl-4" data-id="element-223" data-mp="14nxwb1amonyu">
            <li className="flex items-start" data-id="element-224" data-mp="10o70uka5pjnz">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-225" data-mp="10ne2o7p9k2hg">•</span>
              <span data-id="element-226" data-mp="vpm8t85266am">lectura breve</span>
            </li>
            <li className="flex items-start" data-id="element-227" data-mp="qxuh2ua61uiw">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-228" data-mp="qx2l3icnpus3">•</span>
              <span data-id="element-229" data-mp="ly84mn25wib5">actividad principal</span>
            </li>
            <li className="flex items-start" data-id="element-230" data-mp="lwonyvclg58u">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-231" data-mp="h0g10vs5n7r4">•</span>
              <span data-id="element-232" data-mp="cy38j92f56ca">análisis de situaciones</span>
            </li>
            <li className="flex items-start" data-id="element-233" data-mp="cxjmph9ndxsz">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-234" data-mp="7z8ibm24gfi5">•</span>
              <span data-id="element-235" data-mp="81304ri3jri0">reflexión crítica</span>
            </li>
            <li className="flex items-start" data-id="element-236" data-mp="2jlad1ssgytat">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-237" data-mp="2joobwr1xckdi">•</span>
              <span data-id="element-238" data-mp="2ojvcvr3t7ayq">producción escrita</span>
            </li>
            <li className="flex items-start" data-id="element-239" data-mp="2smiay9r2ps4d">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-240" data-mp="2snt9nv5nw9om">•</span>
              <span data-id="element-241" data-mp="2xl1wwa5o33wq">amplios espacios para responder</span>
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-900 inline-block px-2 mb-2 bg-[#EFF6FF]" data-id="element-242" data-mp="20wn7zaaam3x8">
            Todo pensado especialmente para estudiantes de Secundaria.
          </p>

          <p className="text-lg text-gray-700" data-id="element-243" data-mp="29wse7h3r2w9t">
            Cada página fue diseñada para resolver una clase completa.
          </p>
        </div>

        <div className="text-center mt-5" data-id="element-244" data-mp="2eotleom29wsz">
          <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-245" data-mp="1h7v07q6knlmv">
            🔥 QUIERO MI MEGAPACK ESI SECUNDARIA
          </CTAButton>
        </div>
      </div>
    </section>;
}